/**
 * Copyright (c) S2 Partnership Ltd. 2023 - 2024
 *
 * Controller for the html-modal dialog window that allows html elements inside a modal view.
 *
 * @summary Controller for html-modal dialog window.
 * @author S2 Partnership Ltd
 *
 * Created at     : 04-09-2023
 */

import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { translationObject } from 'src/constants';

@Component({
  selector: 'app-html-modal',
  templateUrl: 'html-modal.component.html',
  styleUrls: ['./html-modal.component.scss']
})
export class HtmlModalComponent {
  /** The HTML string to be displayed as the message of this modal. */
  modalElements: string;
  /** The title of the modal. */
  modalTitle: string;
  /** The dismiss text of the modal. */
  modalDismiss: string;
  /** Stores the current translations used to populate this view. */
  localTranslations = translationObject.currentTranslation;

  /**
   * Standard Angular Constructor
   *
   * @ignore
   */
  constructor(
    /* eslint-disable */
    private modalController: ModalController
    /* eslint-enable */
  ) {}

  /**
   * Callback method for the continue button being pressed on the modal view.
   *
   * @returns {any} A dismiss event will be broadcast.
   */
  dismiss(data?: any, role?: string): any {
    if (role !== 'backdrop') {
        return this.modalController.dismiss(null, 'dismiss');
    } else {
        return false;
    }
  }
}
